/* tslint:disable */
/* eslint-disable */
/**
 * 
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface Value2
 */
export interface Value2 {
}

/**
 * Check if a given object implements the Value2 interface.
 */
export function instanceOfValue2(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function Value2FromJSON(json: any): Value2 {
    return Value2FromJSONTyped(json, false);
}

export function Value2FromJSONTyped(json: any, ignoreDiscriminator: boolean): Value2 {
    return json;
}

export function Value2ToJSON(value?: Value2 | null): any {
    return value;
}

